/**
 * SectionHeader — editorial section heading: Georgia H2 over a single warm
 * hairline rule. (Reworked from the v10 "For Dummies" grammar: the 52×52 navy
 * number badge + 3px bottom border were the loudest of the chunky cues.)
 *
 * `index` is still accepted for back-compat with the ~40 callers that pass a
 * section number or "∗", but it's no longer rendered as a filled badge. When
 * provided it renders as a small crimson kicker numeral above the title, which
 * keeps long multi-section reads scannable without the boxed-number look.
 */

export default function SectionHeader({ index, title, showIndex = true }) {
  // Only numeric indices read well as an editorial kicker. Symbol indices
  // ("∗", "—") that some non-Blueprint surfaces pass are suppressed.
  const isNumeric = index !== undefined && index !== null && /^\d+[a-z]?$/i.test(String(index).trim());
  const hasIndex = showIndex && isNumeric;
  return (
    <div
      style={{
        marginTop: 34,
        marginBottom: 16,
        paddingBottom: 10,
        borderBottom: "1px solid var(--ppr-color-border-default)",
      }}
      data-component="SectionHeader"
    >
      {hasIndex ? (
        <div
          style={{
            fontFamily: "var(--ppr-typography-font-family-mono)",
            fontSize: 11,
            letterSpacing: "0.14em",
            color: "var(--ppr-color-accent-coral)",
            marginBottom: 6,
          }}
        >
          {index}
        </div>
      ) : null}
      <h2
        style={{
          fontFamily: "var(--ppr-typography-font-family-display)",
          fontSize: "var(--ppr-typography-font-size-xl)",
          letterSpacing: "var(--ppr-typography-letter-spacing-snug)",
          color: "var(--ppr-color-text-primary)",
          margin: 0,
          lineHeight: "var(--ppr-typography-line-height-snug)",
          fontWeight: "var(--ppr-typography-font-weight-regular)",
        }}
      >
        {title}
      </h2>
    </div>
  );
}
